import apiClient from "./ApiInterceptor";

export const fetchUsersByRoleIdForBranch = async (role_id, branch_id) => {
    const response = await apiClient.get(`/roles/${role_id}/branch/${branch_id}`);
    return response.data;
}
